module.exports = __webpack_public_path__ + "img/4.c8dc302.png";